import EChart from './EChart';
import {
  aggregateDoctorRevenue,
  aggregatePaymentTypes,
  aggregateRevenue,
  aggregateTechnicianSalary,
  buildBarOption,
  buildPieOption,
  hasChartValues,
} from './chartUtils';

function EmptyChart({ text }) {
  return <div className="chartEmpty">{text}</div>;
}

export function RevenueTab({ orders, t }) {
  const weekly = aggregateRevenue(orders, 'week');
  const monthly = aggregateRevenue(orders, 'month');
  const unit = t.rub;

  return (
    <div className="chartsColumn">
      {hasChartValues(weekly) ? (
        <div className="chartCard">
          <EChart
            height={340}
            option={buildBarOption({
              categories: weekly.map((item) => item.label),
              values: weekly.map((item) => item.value),
              title: t.revenueWeekly,
              unit,
            })}
          />
        </div>
      ) : (
        <EmptyChart text={t.noChartData} />
      )}
      {hasChartValues(monthly) ? (
        <div className="chartCard">
          <EChart
            height={320}
            option={buildBarOption({
              categories: monthly.map((item) => item.label),
              values: monthly.map((item) => item.value),
              title: t.revenueMonthly,
              unit,
            })}
          />
        </div>
      ) : null}
    </div>
  );
}

export function TechniciansTab({ orders, technics, t }) {
  const rows = aggregateTechnicianSalary(orders, technics, t.unknownTechnician);
  if (!hasChartValues(rows)) return <EmptyChart text={t.noChartData} />;

  return (
    <div className="chartCard">
      <EChart
        height={Math.max(360, rows.length * 28 + 120)}
        option={buildBarOption({
          categories: rows.map((item) => item.name),
          values: rows.map((item) => item.value),
          title: t.salaryByTechnician,
          unit: t.rub,
          horizontal: true,
        })}
      />
    </div>
  );
}

export function DoctorsTab({ orders, t }) {
  const rows = aggregateDoctorRevenue(orders, t.unknownDoctor);
  if (!hasChartValues(rows)) return <EmptyChart text={t.noChartData} />;

  return (
    <div className="chartCard">
      <EChart
        height={Math.max(360, rows.length * 28 + 120)}
        option={buildBarOption({
          categories: rows.map((item) => item.name),
          values: rows.map((item) => item.value),
          title: t.revenueByDoctor,
          unit: t.rub,
          horizontal: true,
        })}
      />
    </div>
  );
}

export function PaymentTab({ orders, t }) {
  const data = aggregatePaymentTypes(orders, t);
  if (!hasChartValues(data)) return <EmptyChart text={t.noChartData} />;

  return (
    <div className="chartCard">
      <EChart
        height={380}
        option={buildPieOption({
          data,
          title: t.cashVsNonCash,
          unit: t.rub,
        })}
      />
    </div>
  );
}
